import React, { useState, useEffect, useRef } from 'react';
import Cookies from "js-cookie";

function DemoAvatar () {

    const [frame1, setFrame1] = useState('');
    const [frame2, setFrame2] = useState('');
    const [frame3, setFrame3] = useState('');

    let player_1 = Cookies.get("player_id_1");
    let player_2 = Cookies.get("player_id_2");
    let player_3 = Cookies.get("player_id_3");
    let game_id = Cookies.get("game_id");

    useEffect(() => {
      setFrame1(window.location.origin + '/app/game/avatar/'+ game_id + '/' + player_1 + '?demo=true&player=1');
      setFrame2(window.location.origin + '/app/game/avatar/'+ game_id + '/' + player_2 + '?demo=true&player=2');
      setFrame3(window.location.origin + '/app/game/avatar/'+ game_id + '/' + player_3 + '?demo=true&player=3');
    }, []);
    return (
    <div className="demoContainer">
        <div className="demoColumn">
          <iframe className="demoFrame" src={frame1} width="100%" height="100%" >
            <p>loading....</p>
          </iframe>
        </div>
        <div className="demoColumn">
          <iframe className="demoFrame" src={frame2} width="100%" height="100%">
            <p>loading....</p>
          </iframe>
        </div>
        <div className="demoColumn">
          <iframe className="demoFrame" src={frame3} width="100%" height="100%">
            <p>loading....</p>
          </iframe>
        </div>
    </div>
    )
}

export default DemoAvatar;